export default __webpack_public_path__ + "static/media/icon-activity-emailchanged.3f76af55.svg";